import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import dollarImage from '../../assets/images/gavel.svg';

const HearingsTab = ({ unit, openHearingWindow }) => {
  return (
    <div>
      {unit.hearings && unit.hearings.length > 0 &&
        <div className='hearing-container col-12 col-sm-12 col-md-12'>
          <div className='flex-container'>
            <div className='dollar-container sub-title'>Hearing</div>
            <div className='date-container sub-title'>Date & Time</div>
            <div className='location-container sub-title'>Location</div>
          </div>
          {unit.hearings.map((hearing, i) => (
            <div className='flex-container' key={i}>
              <div className='dollar-container'>
                <div>
                  <img src={dollarImage} />
                  {hearing.description}
                </div>
              </div>
              <div className='date-container'>
                <span
                  className={hearing.hearingNotice ? 'has-link' : ''}
                  onClick={() => openHearingWindow(hearing)}
                >
                  <span
                    style={{
                      display: 'block',
                      marginLeft: 'auto',
                      textAlign: 'left'
                    }}
                  >
                    {`${moment(hearing.hearingDt).format(
                      'YYYY-MM-DD'
                    )} ` +
                        `${
                          moment(hearing.hearingDt).format(
                            'h:mm:ss a'
                          ) !== '12:00:00 am'
                            ? moment(hearing.hearingDt).format(
                              'h:mm:ss a'
                            )
                            : ''
                        }`}
                  </span>
                </span>
              </div>
              <div className='location-container'>
                <span>{hearing.location}</span>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
};

HearingsTab.propTypes = {
  openHearingWindow: PropTypes.func.isRequired,
  unit: PropTypes.any,
};

export default HearingsTab;
